import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Badge } from './ui/Badge';
export function ProofSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const timeline = [{
    days: '7 días',
    text: 'Verás los primeros brotes asomando por la superficie'
  }, {
    days: '15 días',
    text: 'Tu balcón habrá dejado de ser un espacio gris para ser una mancha verde visible desde la calle'
  }, {
    days: '30 días',
    text: 'Estarás cortando tu primera ración de rúcula orgánica'
  }];
  return <section ref={ref} className="w-full py-10 md:py-16 bg-gradient-to-b from-[#95D5B2] to-[#D8F3DC]" data-id="element-192">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-194">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#2D6A4F] mb-4" data-id="element-195">
            Tu Cronograma de Éxito
          </h2>
        </motion.div>

        <div className="space-y-4 mb-8" data-id="element-196">
          {timeline.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2 + index * 0.1
        }} className="bg-white rounded-xl p-4 shadow-lg flex gap-3 items-start" data-id="element-197">
              <Badge className="bg-[#2D6A4F] text-white text-xs font-bold px-2.5 py-1 flex-shrink-0" data-id="element-198">
                {item.days}
              </Badge>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-199">
                {item.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-center" data-id="element-200">
          <p className="text-lg md:text-xl text-[#2D6A4F] font-medium italic" data-id="element-201">
            No es magia, es biología aplicada al espacio urbano.
          </p>
        </motion.div>
      </div>
    </section>;
}